import { SettingOutlined } from '@ant-design/icons';
import { Button, Popover, Tooltip } from 'antd';

import type { ReactNode } from 'react';

const SETTINGS_POPOVER_ROOT_CLASS = 'data-table-settings-popover';

type SettingsPopoverProps = {
  content: ReactNode;
  tooltip: string;
  'aria-label': string;
  'data-testid'?: string;
};

/**
 * Shared settings-gear popover chrome used by DataTableSettings and kanban
 * visible-stages (and any future listing gear menus).
 */
export function SettingsPopover({
  content,
  tooltip,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
}: SettingsPopoverProps) {
  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottomRight"
      classNames={{ root: SETTINGS_POPOVER_ROOT_CLASS }}
    >
      <Tooltip title={tooltip}>
        <Button
          icon={<SettingOutlined />}
          aria-label={ariaLabel}
          data-testid={dataTestId}
        />
      </Tooltip>
    </Popover>
  );
}
